<template>
  <LabelledInput
    label="Select story to edit"
  >
    <StoryPicker
      :selected-story-path.sync="selectedStoryPath"
    />
  </LabelledInput>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import StoryPicker from '@/components/builder/StoryEditor/StoryPicker.vue'

import {
  DEFAULT_STORY_KEY,
} from '@/constants'

const components = {
  LabelledInput,
  StoryPicker,
}

@Component({ components })
export default class ActivatePathStoryPicker extends Vue {
  get selectedStoryPath () {
    return this.$typedStore.public.display.defaultStoryPathToEdit ?? this.$typedStore.public.display.storyPath.toString()
  }

  set selectedStoryPath (path) {
    if (new RegExp(DEFAULT_STORY_KEY + '[0-9]+').test(path.toString())) {
      this.$typedStore.public.display.setDefaultStoryPathToEdit(path.toString())
    } else {
      this.$typedStore.public.display.setDefaultStoryPathToEdit(null)
      this.$typedStore.public.display.updatePrimaryStoryPath(path)
    }
  }
}

</script>
